export default __webpack_public_path__ + "static/media/werking-wheather-2.fb230ad7.JPG";